import { render } from "./ModelBasicCard.vue?vue&type=template&id=64a49740"
import script from "./ModelBasicCard.vue?vue&type=script&lang=js"
export * from "./ModelBasicCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__